/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import PlusOrdersSet from '../../../interfaces/platform/PlusOrdersSet';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { provConstant } from '../../../modules/provisioning/ProvisioningConnect';
import ApiCollectionResponseInterface from '../../../interfaces/api/ApiCollectionResponseInterface';
import { Card, Typography } from '@material-ui/core';
import CardHeader from '../../../components/Card/CardHeader';
import I18n from '../../../components/Translate/I18n';
import CardBody from '../../../components/Card/CardBody';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import PlusOrdersSetResponseInterface from '../../../interfaces/platform/PlusOrdersSetResponseInterface';
import { DateHelper } from '../../../helpers/DateHelper';
import XmlView from './XmlView';

interface PlusOrdersSetResponseListCollectionInterface extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<PlusOrdersSetResponseInterface> | null;
}

interface PlusOrdersSetResponseProps {
    dispatch: any;
    item: PlusOrdersSet;
}

interface PlusOrdersSetResponseState {
    items: PlusOrdersSetResponseListCollectionInterface | null;
}

class PlusOrdersSetResponse extends PureComponent<PlusOrdersSetResponseProps, PlusOrdersSetResponseState> {
    private loaderCall: ItemLoaders;

    constructor(props: PlusOrdersSetResponseProps, context: PlusOrdersSetResponseState) {
        super(props, context);
        this.state = {
            items: null,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount(): void {
        const { item } = this.props;
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/plus_orders_set_responses')),
            provConstant.PLK_ORDERS_LIST,
            [{ name: 'plusOrdersSetId', value: item.id }],
            [],
            (data: PlusOrdersSetResponseListCollectionInterface): void => {
                this.setState({
                    items: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }

    getRequest = (responseMessage: any | null): string | null => {
        if (!responseMessage || !responseMessage.XML_REQUEST) {
            return responseMessage.RDESC;
        }

        return responseMessage.XML_REQUEST;
    };

    getResponse = (responseMessage: any | null): string | null => {
        if (!responseMessage || !responseMessage.XML_RESPONSE) {
            return null;
        }
        return responseMessage.XML_RESPONSE;
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { items } = this.state;
        const { item } = this.props;

        if (items && items['hydra:totalItems'] !== 0 && items['hydra:member']) {
            let count = 0;
            return (
                <GridContainer>
                    <GridItem xs={12}>
                        <Typography variant="body2" color="primary">
                            <I18n trans="prov:api.api_plk_method_call" valueObject={{ function_name: item.command }} />
                        </Typography>

                        <GridContainer>
                            {items &&
                                items['hydra:member'] &&
                                items['hydra:member'].map((response) => {
                                    count++;
                                    let json: any = null;
                                    if (response.responseMessage) {
                                        json = JSON.parse(response.responseMessage);
                                    }
                                    return (
                                        <GridItem xs={12} key={'plk_response_set_' + response.id}>
                                            <Card>
                                                <CardHeader>
                                                    <Typography variant="subtitle2">
                                                        <I18n
                                                            trans="prov:api.api_plk_request"
                                                            valueObject={{ count: count, time: DateHelper.format(response.requestTime) }}
                                                        />
                                                    </Typography>
                                                </CardHeader>
                                                <CardBody>{XmlView(this.getRequest(json))}</CardBody>
                                                <CardHeader>
                                                    <Typography variant="subtitle2">
                                                        <I18n
                                                            trans="prov:api.api_plk_response"
                                                            valueObject={{ time: DateHelper.format(response.responseTime) }}
                                                        />
                                                    </Typography>
                                                </CardHeader>
                                                <CardBody>{XmlView(this.getResponse(json))}</CardBody>
                                            </Card>
                                        </GridItem>
                                    );
                                })}
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            );
        }
        return null;
    }
}

const mapStateToProps = (state: any): object => {
    return {};
};

export default compose<any, any>(connect(mapStateToProps), withStyles(adescomStyle))(PlusOrdersSetResponse);
